import { Check, Users, Globe } from "lucide-react";

export type WheelhouseStatus = "in_wheelhouse" | "other_portco" | "general";

export function WheelhouseBadge({
  status,
  size = "sm",
  showLabel = true,
}: {
  status: WheelhouseStatus;
  size?: "xs" | "sm" | "md";
  showLabel?: boolean;
}) {
  const cfg = {
    in_wheelhouse: {
      label: "In your wheelhouse",
      short: "Yours",
      cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
      Icon: Check,
    },
    other_portco: {
      label: "Other portco",
      short: "Other",
      cls: "bg-amber-500/12 text-amber-300 border-amber-500/30",
      Icon: Users,
    },
    general: {
      label: "General",
      short: "General",
      cls: "bg-slate-500/12 text-slate-300 border-slate-500/25",
      Icon: Globe,
    },
  }[status];
  const sizing = size === "xs"
    ? "text-[9px] px-1.5 py-0.5"
    : size === "md" ? "text-[11px] px-2.5 py-1" : "text-[10px] px-2 py-0.5";
  const iconSize = size === "md" ? "w-3.5 h-3.5" : "w-3 h-3";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border font-mono uppercase tracking-wider font-semibold ${cfg.cls} ${sizing}`}>
      <cfg.Icon className={iconSize} />
      {showLabel && <span>{size === "md" ? cfg.label : cfg.short}</span>}
    </span>
  );
}

// Helper: derive status from a task / company in the banker UI.
export function statusFor(coveredCompanyIds: number[], companyId: number | null | undefined): WheelhouseStatus {
  if (!companyId) return "general";
  return coveredCompanyIds.includes(companyId) ? "in_wheelhouse" : "other_portco";
}
